<template>
  <div class="status-wave" @click="$emit('click', wave.WaveGuid)">
    <div class="status-wave-meta-data">
      <span><b>{{ wave.WaveName }}</b></span>
      <span>{{ globals.toLocaleDateString(wave.WaveSince) }} - {{ globals.toLocaleDateString(wave.WaveUntil) }}</span>
    </div>
    <!-- Check Status -->
    <div class="kpis">
      <template v-if="wave.SurveyInstances && wave.SurveyInstances.Status">
        <StatIndicator
          :value="wave.SurveyInstances.Status.Count"
          :label="'Count'"
          :centerText="wave.SurveyInstances.Status.Count"
          :showRing="false"
          :showSquare="true"
        />
        <StatIndicator
          :value="wave.SurveyInstances.Status.Approval"
          :label="'Approval'"
          :centerText="wave.SurveyInstances.Status.Approval"
          :showRing="false"
          :showSquare="true"
        />
        <StatIndicator
          :value="wave.SurveyInstances.Status.InProgress"
          :label="'InProgress'"
          :centerText="wave.SurveyInstances.Status.InProgress"
          :showRing="false"
          :showSquare="true"
        />
        <StatIndicator
          :value="wave.SurveyInstances.Status.Reporting"
          :label="'Reporting'"
          :centerText="wave.SurveyInstances.Status.Reporting"
          :showRing="false"
          :showSquare="true"
        />
      </template>
      <template v-if="wave.Wave">
        <StatIndicator
          :value="wave.Wave.InTime"
          :label="'InTime'"
          :centerText="wave.Wave.InTime"
          :isPercentage="true"
          suffix="%"
        />        
      </template>
    </div>
    <!-- Approvals -->
    <div class="kpis">
      <template v-if="wave.Approvals">
        <StatIndicator
          :value="wave.Approvals.None"
          :label="'None'"
          :centerText="wave.Approvals.None"
          :isPercentage="true"
          suffix="%"
        />
        <StatIndicator
          :value="wave.Approvals.Open"
          :label="'Open'"
          :centerText="wave.Approvals.Open"
          :isPercentage="true"
          suffix="%"
        />
        <StatIndicator
          :value="wave.Approvals.Approved"
          :label="'Approved'"
          :centerText="wave.Approvals.Approved"
          :isPercentage="true"
          suffix="%"
        />
      </template>
    </div>
    <!-- <div class="spacer"></div> -->
  </div>
</template>

<script>
import StatIndicator from '../Tools/StatIndicator.vue';

export default {
  name: 'StatusWave',
  components: { StatIndicator },
  props: {
    wave: null
  },
};
</script>

<style scoped>
.status-wave {
  background: white;
  border: 1px solid lightgray;
  margin: 12px 0px;
  padding: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  transition: all .2s;
  cursor: pointer;
}

.status-wave:hover {
  border: 1px solid var(--color-primary);
  box-shadow: 0px 5px 5px rgb(206, 206, 206);
  transform: translateY(-2px);
}

.status-wave-meta-data {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  width: 33%;
}

.kpis {
  width: 33%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// StatusWave.vue?bf922534